// validations/authValidation.js
import * as Yup from "yup";

export const mobileSchema = Yup.object().shape({
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit mobile number"),
  acceptedTerms: Yup.boolean().oneOf(
    [true],
    "Please accept the terms and conditions",
  ),
});

export const otpSchema = Yup.object().shape({
  otp: Yup.string()
    .required("OTP is required")
    .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit OTP"),
});

export const registerSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must be less than 50 characters"),
  email: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email address"),
  city_id: Yup.number()
    .typeError("Please select a city")
    .required("Please select a city")
    .integer("Please select a valid city"),
  pincode: Yup.string()
    .required("Pincode is required")
    .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit pincode"),
  otp: Yup.string()
    .required("OTP is required")
    .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit OTP"),
});